import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/:projectId',
  //   name: 'loading',
  //   component: () => import('../views/loading.vue')
  // },
  {
  path: '/:projectId',
  name: 'index',
  component: () => import('../views/index.vue')
}]
const router = new VueRouter({
  routes
})

export default router